export default __webpack_public_path__ + "static/bg-blue-e9d3b3cf8eab7b555e73fb98df2f2711.jpg";